module.exports = __webpack_public_path__ + "img/CClogo-horizontal.3664a8a0.png";